import React from "react";
import Loading from "../Loading";
import {
  isValidTransactionType,
  dateWithMonthAndTimeString,
} from "../utilities/utils";
import { MDBTooltip } from "mdb-react-ui-kit";
import History from "../../constants/History";

const HistoryTransactTable = ({
  historyTransactInfo,
  addCommas,
  loading,
  balanceForwardTransact,
  roBalanceForwardTransact,
  fpBalanceForwardTransact,
  openWagerDetailsModal,
  openActionDetailModal,
}) => {
  let headers,
    tableContent = [],
    detailsHistory = [],
    derPtsHistory = [],
    trBalanceDefault;

  trBalanceDefault = (
    <tr style={{ backgroundColor: "rgba(217, 230, 242, 0.7)" }}>
      <td></td>
      <td></td>
      <td
        style={{
          textAlign: "center",
          fontWeight: "bold",
          color: "rgb(0, 102, 153)",
        }}
      >
        Balance Forward
      </td>
      <td colSpan={5}></td>
      <td
        style={{
          textAlign: "center",
          fontWeight: "bold",
          color: "rgb(0, 102, 153)",
        }}
      >
        {balanceForwardTransact !== "0" &&
          addCommas(parseFloat(balanceForwardTransact).toFixed(2))}
      </td>
      <td></td>
      <td
        style={{
          textAlign: "center",
          fontWeight: "bold",
          color: "rgb(0, 102, 153)",
        }}
      >
        {roBalanceForwardTransact !== "0" &&
          addCommas(parseFloat(roBalanceForwardTransact).toFixed(2))}
      </td>
      <td></td>
      <td
        style={{
          textAlign: "center",
          fontWeight: "bold",
          color: "rgb(0, 102, 153)",
        }}
      >
        {fpBalanceForwardTransact !== "0" &&
          addCommas(parseFloat(fpBalanceForwardTransact).toFixed(2))}
      </td>
      <td colSpan={4}></td>
    </tr>
  );

  //Charge History Transact Table
  if (historyTransactInfo) {
    let status, actions, taxAmount, derPts, sport;
    tableContent = historyTransactInfo.map((data, i) => {
      sport = "";
      status = "LOSE";
      actions = "";

      if (data.Result) {
        switch (data.Result) {
          case 1:
            status = "WIN";
            break;
          case 2:
            status = "PUSH";
            break;
          case 3:
            status = "NO BET";
            break;
          case 4:
            status = "N/A";
            break;
          case 5:
            status = "N/A PITCHER";
            break;
          case 6:
            status = "N/A CANCEL";
            break;
          case 7:
            status = "N/A SHORT";
            break;
          case 8:
            status = "VOID";
            break;
          case 255:
            status = "PEND";
            break;
          case 9:
            status = "WIN BY 1/4";
            break;
          case 10:
            status = "LOSE BY 1/4";
            break;
          case 11:
            status = "WIN BY 3/4";
            break;
          case 12:
            status = "LOSE BY 3/4";
            break;
          case 13:
            status = "DELETED";
            break;
          case 14:
            status = "CASHOUT";
            break;
          default:
            return null; // Ensure there's a return value
        }
      }

      if (data.WAction) {
        switch (data.WAction) {
          case 0:
            actions = "";
            break;
          case 1:
            actions = "SOLD";
            break;
          case 2:
            actions = "GRADED";
            break;
          case 3:
            actions = "UNGRADED";
            break;
          case 4:
            actions = "VOIDED";
            break;
          case 5:
            actions = "CASHED OUT";
            break;
          default:
            return null; // Ensure there's a return value
        }
      }

      taxAmount = data.TaxAmount === "0" ? "" : data.TaxAmount;

      detailsHistory = [];
      derPtsHistory = [];
      if (data.Details) {
        data.Details.map((detail, j) => {
          derPts =
            detail.DerivativePoints === "0" ? "" : detail.DerivativePoints;
          detailsHistory.push(
            <p
              key={"detDesc" + j}
              style={{
                textAlign: "center",
                wordWrap: "break-word",
                whiteSpace: "normal",
                width: "200px",
              }}
            >
              {detail.DetailDescription}
            </p>,
          );
          derPtsHistory.push(
            <p
              key={"derPts" + j}
              style={{
                textAlign: "center",
                wordWrap: "break-word",
                whiteSpace: "normal",
              }}
            >
              {derPts}
            </p>,
          );

          sport = detail.IdSport;
        });
      } else {
        switch (data.TransactionType) {
          case "A":
            sport = "ADJ";
            break;
          case "B":
            sport = "BALANCE FWD";
            break;
          case "C":
            sport = "ACCRU";
            break;
          case "D":
            sport = "DISB";
            break;
          case "F":
            sport = "CHECK FIGURE";
            break;
          case "H":
            sport = "H ADJ";
            break;
          case "I":
            sport = "WAGER CHILD";
            break;
          case "K":
            sport = "CASINO";
            break;
          case "O":
            sport = "HORSE WAGER";
            break;
          case "P":
            sport = "FREE";
            break;
          case "R":
            sport = "RCPT";
            break;
          case "T":
            sport = "XFER";
            break;
          case "V":
            sport = "RO";
            break;
          case "W":
            sport = "WAGER";
            break;
          default:
            return null; // Ensure there's a return value
        }
      }

      const formatDateUTC = (date) => {
        if (!date) return "-";
        const d = new Date(date);
        return d.toLocaleDateString("en-US", {
          month: "2-digit",
          day: "2-digit",
          year: "numeric",
        });
      };

      const formatTimeUTC = (date) => {
        if (!date) return "-";
        const d = new Date(date);
        return d
          .toLocaleTimeString("en-US", {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
          })
          .toLowerCase();
      };

      const addCommas = (num) => {
        if (!num) return "0.00";
        return parseFloat(num)
          .toFixed(2)
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      };

      const formatAction = (wAction) => {
        const actions = {
          1: "SOLD",
          2: "GRADED",
          3: "UNGRADED",
          4: "VOIDED",
          5: "CASHED OUT",
        };
        return actions[wAction] || "";
      };

      return (
        <React.Fragment key={i}>
          <tr
            key={"tr" + data.TicketNumber}
            className="entryTR"
            style={{ verticalAlign: "middle", cursor: "pointer" }}
            onClick={() => openWagerDetailsModal(data)}
          >
            <td className="d-none">{data.IdWager}</td>

            {/* Ticket Number and Date */}
            <td className="text-center" style={{ width: "150px" }}>
              {data.TicketNumber !== 0 && (
                <p className="m-0  font-weight-bold ">
                  Ticket #{data.TicketNumber}
                </p>
              )}

              {data.Details && data.Details.length > 0 ? (
                data.Details.map((detail, index) => (
                  <React.Fragment key={`${data.TicketNumber}-date-${index}`}>
                    {detail.UIDescription !== "OPEN PLAY" && (
                      <>
                        <p className="m-0">
                          {dateWithMonthAndTimeString(data.LastModification)}
                        </p>
                        {(detail.DetailDescription?.includes("\n") ?? "") && (
                          <br></br>
                        )}
                      </>
                    )}
                  </React.Fragment>
                ))
              ) : (
                <p className="mb-0">
                  {dateWithMonthAndTimeString(data.LastModification)}
                </p>
              )}
            </td>

            {/* Sport */}
            <td className="text-center" style={{ verticalAlign: "top" }}>
              {data.Details && data.Details.length > 0 ? (
                <>
                  {data.IDProduct === History.IDProductCB ? (
                    <p className="p-0 m-0">
                      <MDBTooltip
                        tag="span"
                        wrapperProps={{ href: "#" }}
                        title="Chat Bet"
                      >
                        <span
                          style={{
                            borderRadius: "20px",
                            fontSize: "0.75rem",
                            color: "#fff",
                          }}
                          class="badge bg-info px-2"
                        >
                          CB
                        </span>
                      </MDBTooltip>
                    </p>
                  ) : (
                    <br />
                  )}
                  {data.Details.map((detail, index) => {
                    const detailDesc =
                      detail.DetailDescription?.includes("\n") ?? "";
                    return (
                      <React.Fragment key={index}>
                        <p className="p-0 m-0">{detail.IDSport}</p>
                        {detailDesc && <br />}
                      </React.Fragment>
                    );
                  })}
                </>
              ) : (
                <p>{data.TransactionTypeDescription}</p>
              )}
            </td>

            {/* Description */}
            <td
              className="text-left"
              style={{ width: "250px", verticalAlign: "top" }}
            >
              <p className="mb-0  font-weight-bold ">
                {data?.HeaderDescription || data?.Description}
              </p>
              {data.Details &&
                data.Details.map((detail, index) => (
                  <p key={index} className="mb-0">
                    {detail.IsSGP && (
                      <span
                        style={{
                          borderRadius: "20px",
                          fontSize: "0.75rem",
                          color: "#fff",
                          marginRight: "10px",
                        }}
                        class="badge bg-primary"
                      >
                        SGP
                      </span>
                    )}
                    {detail.IsEarlyPO && (
                      <MDBTooltip
                        tag="span"
                        wrapperProps={{ href: "#" }}
                        title="Early Payout"
                      >
                        <span
                          style={{
                            borderRadius: "20px",
                            fontSize: "0.75rem",
                            color: "#fff",
                            marginRight: "10px",
                          }}
                          class="badge bg-success"
                        >
                          EP
                        </span>
                      </MDBTooltip>
                    )}
                    <span style={{ whiteSpace: "pre-line" }}>
                      {detail.DetailDescription}
                    </span>
                  </p>
                ))}
            </td>

            {/* Derivative Points */}
            <td className="text-center" style={{ verticalAlign: "middle" }}>
              {data.Details &&
                data.Details.map((detail, index) => (
                  <p key={index} className="mb-0">
                    {detail.DerivativePoints || ""}
                  </p>
                ))}
            </td>

            {/* WIN/LOSE */}
            <td
              className="text-center fw-bold"
              style={{ verticalAlign: "middle" }}
            >
              <p className="mb-0 fw-bold" style={{ fontWeight: "bold" }}>
                {data.ResultDescription.toUpperCase() || ""}
              </p>

              {data.Details &&
                data.Details.map((detail, index) => {
                  const detailDesc =
                    detail.DetailDescription?.includes("\n") ?? "";

                  return (
                    <React.Fragment key={index}>
                      {detail.UIDescription !== "OPEN PLAY" && (
                        <p className="mb-1 fw-bold">
                          {detail.DetailResultDescription.toUpperCase() || ""}
                        </p>
                      )}
                      {detailDesc && <br></br>}
                    </React.Fragment>
                  );
                })}
            </td>

            {/* Risk / Win */}
            <td className="text-right" style={{ verticalAlign: "middle" }}>
              {addCommas(data.RiskAmount)}/{addCommas(data.WinAmount)}
            </td>

            {/* Amount */}
            <td className="text-right" style={{ verticalAlign: "middle" }}>
              {addCommas(data.Amount)}
            </td>

            {/* TaxAmount */}
            <td className="text-right" style={{ verticalAlign: "middle" }}>
              {data.TaxAmount !== 0 ? addCommas(data.TaxAmount) : ""}
            </td>

            {/* Balance */}
            <td className="text-right" style={{ verticalAlign: "middle" }}>
              {addCommas(data.Balance)}
            </td>

            {/* RO Amount */}
            <td style={{ textAlign: "center", verticalAlign: "middle" }}>
              {data.ROAmount !== 0 ? addCommas(data.ROAmount) : "0.00"}
            </td>

            {/* RO Balance */}
            <td style={{ textAlign: "center", verticalAlign: "middle" }}>
              {addCommas(Number(data.ROBalance) || "0.00")}
            </td>

            {/* FP Amount */}
            <td style={{ textAlign: "center", verticalAlign: "middle" }}>
              {data.FPAmount !== 0 ? addCommas(data.FPAmount) : "0.00"}
            </td>

            {/* FP Balance */}
            <td style={{ textAlign: "center", verticalAlign: "middle" }}>
              {data.FPBalance !== 0 ? addCommas(data.FPBalance) : "0.00"}
            </td>

            {/* LoginName */}
            <td className="text-center" style={{ verticalAlign: "middle" }}>
              {data.LoginName}
            </td>

            {/* WAction */}
            <td
              className="text-center fw-bold"
              style={{ fontWeight: "bold", verticalAlign: "middle" }}
            >
              {formatAction(data.WAction)}
            </td>

            {/* LastModification*/}
            <td className="text-center" style={{ verticalAlign: "middle" }}>
              <p className="mb-0">
                {formatDateUTC(data.LastModification)}
                {formatTimeUTC(data.LastModification)}
              </p>
            </td>

            {/* Action Detalles */}
            <td
              style={{
                textAlign: "center",
                verticalAlign: "middle",
              }}
            >
              {isValidTransactionType(data.TransactionType) && (
                <MDBTooltip
                  tag="i"
                  wrapperProps={{ href: "#" }}
                  title="View Details"
                >
                  <i
                    className="feather icon-info hover-bold"
                    style={{
                      color: "#006699",
                      fontSize: "18px",
                      cursor: "pointer",
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      openActionDetailModal(data);
                    }}
                  ></i>
                </MDBTooltip>
              )}
            </td>
          </tr>
        </React.Fragment>
      );
    });
  }

  headers = (
    <tr className="text-center header-tbEntries" style={{ color: "#fff" }}>
      <th hidden>TicketID</th>
      <th style={{ width: "100px" }}>Date</th>
      <th style={{ width: "80px" }}></th>
      <th>Description</th>
      <th style={{ width: "80px" }}>Der.Pts</th>
      <th>Status</th>
      <th>Risk/Win</th>
      <th>Amount</th>
      <th>Tax</th>
      <th>Balance</th>
      <th>RO Amount</th>
      <th>RO Balance</th>
      <th>FP-Amount</th>
      <th>FP-Balance</th>
      <th>User</th>
      <th>Action</th>
      <th>Last Mod.</th>
      <th>Details</th>
    </tr>
  );

  return (
    <>
      {loading && <Loading />}
      <table className="table table-striped table-sm">
        <thead style={{ position: "sticky", top: "0", background: "#005580" }}>
          {headers}
        </thead>

        <tbody className="table-sm">
          {trBalanceDefault}
          {tableContent}
        </tbody>
      </table>
    </>
  );
};

export default HistoryTransactTable;
